import React, {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {getPaymodeColor} from '../../../../_components/colors'
import {MoneyCell, NumberCell} from '@/components/table/columns'
import {ReactCountryFlag} from 'react-country-flag'
import {KTIcon} from '@/_metronic/helpers'

type StatusCellProps = {
  status: string
}

const TrxStatusCell: FC<StatusCellProps> = ({status}) => {
  const intl = useIntl()

  return (
    <div className={clsx('badge', {
      'badge-light-primary': status === 'PENDING',
      'badge-light-success': status === 'SUCCEED',
      'badge-light-danger': !['PENDING', 'SUCCEED'].includes(status),
    })}>
      {intl.formatMessage({id: `P2C.TRX_STATUS_${status}`})}
    </div>
  )
}

type PaymodeCellProps = {
  paymode?: string
  country?: string
}

const TrxPaymodeCell: FC<PaymodeCellProps> = ({paymode, country}) => {
  const intl = useIntl()
  return (
    <div>
      {!paymode ? (
        <>-</>
      ) : (
        <>
          {country && (
            <ReactCountryFlag
              countryCode={country}
              style={{ fontSize: '1.5em' }}
              className='me-3'
            />
          )}
          <div className={`badge badge-light-${getPaymodeColor(paymode)}`}>
            {intl.formatMessage({id: `P2C.PAYMODE_${paymode.toUpperCase()}`})}
          </div>
        </>
      )}
    </div>
  )
}

type CreditCellProps = {
  credit?:number
  status: string
}

const TrxCreditCell: FC<CreditCellProps> = ({credit, status}) => {
  if (!credit) {
    return (
      <>
        {status === 'SUCCEED' && (
          <span title="Missing credits">
            <KTIcon iconName='information' className='fs-1 text-danger' />
          </span>
        )}
      </>
    )
  }

  return (
    <NumberCell
      value={credit}
      options={{
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }}
    />
  )
}

type AmountCellProps = {
  amount?: number
  currency?: string
}

const TrxAmountCell: FC<AmountCellProps> = ({amount, currency}) => {
  if (amount && currency) {
    return (
      <MoneyCell amount={amount} currency={currency} />
    )
  }

  return (<></>)
}

export {
  TrxStatusCell,
  TrxPaymodeCell,
  TrxAmountCell,
  TrxCreditCell
}
